import React from "react";
import ServiceTemplate from "../../components/templates/ServiceTemplate";
import homeBg from "../../assets/images/produtos/residencial.webp";

const HomeInsurance = () => {
  const serviceData = {
    heroImage: homeBg,
    title: "Seguro Residencial",
    artigo: "um",
    subtitle: "Proteja seu lar contra imprevistos com tranquilidade e economia",
    color: "blue",
    icon: "home",
    ramo: "Residencial",
    pageRamo: true,
    showEmail: true,
    showVeiculo: false,
    formUrl:
      "https://docs.google.com/forms/d/e/1FAIpQLScQc-SPygWVNQn0Zl1IUIqvtMl73Xa1sa_6qW7IaBalG3J5Ug/formResponse",
    mainContent: [
      "O seguro residencial é a melhor forma de proteger seu patrimônio contra diversos imprevistos como incêndios, furtos, danos elétricos e desastres naturais. Com o seguro residencial da Free Market Seguros, você garante segurança para sua casa e tranquilidade para sua família.",
      "Trabalhamos com as principais seguradoras do mercado, oferecendo planos acessíveis e com coberturas que se adaptam ao seu tipo de residência e às suas necessidades específicas.",
    ],
    coverages: [
      "Incêndio, raio e explosão",
      "Roubo ou furto qualificado de bens",
      "Danos elétricos",
      "Vendaval, granizo e alagamento",
      "Responsabilidade civil familiar",
    ],
    additionalCoverages: [
      "Quebra de vidros",
      "Despesas com aluguel temporário",
      "Assistência 24h (chaveiro, encanador, eletricista)",
      "Danos a jardins",
      "Cobertura para eletrodomésticos",
    ],
    advantages: [
      {
        icon: "home",
        title: "Segurança para seu Lar",
        description:
          "Proteção contra os principais riscos que podem afetar sua residência",
      },
      {
        icon: "tools",
        title: "Assistência 24h",
        description:
          "Serviços emergenciais disponíveis a qualquer hora do dia",
      },
      {
        icon: "hand-holding-usd",
        title: "Custo Acessível",
        description:
          "Planos com excelente custo-benefício para proteger seu imóvel",
      },
    ],
    steps: [
      {
        title: "Análise do Imóvel",
        description:
          "Levantamos as informações sobre seu imóvel e seus bens para oferecer o plano ideal.",
      },
      {
        title: "Simulação Personalizada",
        description:
          "Apresentamos as melhores opções de coberturas e seguradoras para sua residência.",
      },
      {
        title: "Contratação Rápida",
        description:
          "Você escolhe o plano ideal e finalizamos tudo com agilidade e sem burocracia.",
      },
      {
        title: "Proteção Ativa",
        description:
          "Você conta com suporte especializado e assistência sempre que precisar.",
      },
    ],
    tip: "Ao contratar um seguro residencial, verifique se as coberturas atendem às características do seu imóvel e aos bens que deseja proteger. A inclusão de assistência 24h pode ser um grande diferencial para emergências do dia a dia.",
  };

  return <ServiceTemplate {...serviceData} />;
};

export default HomeInsurance;